// 官网
export default [
  {
    path: '/portal',
    redirect: '/portal/home',
  },
  {
    path: '/portal/home',
    name: 'website-home',
    component: () => import(/* webpackChunkName: "sys" */ '@/views/website/home/Index.vue'),
    meta: { title: '官网首页管理' },
  },
];
